<template>
  <div class="main">
    <mt-header fixed :title="$t('安全等级')" class="dl_header_white">
      <mt-button icon="back" slot="left" @click="$router.back()"></mt-button>
    </mt-header>
    <div class="content">
      <div class="swiper">
        <p class="wx_fontSize2 tip">
          {{
            $t(
              "为了您的资金安全，需要进一步的安全设置和实名信息才可以提币，提币限额会随之增加。"
            )
          }}
        </p>
      </div>
      <div
        v-for="(item, index) in list"
        :key="index"
        @click="goWhere(item.type)"
        :class="
          userInfo.auth_id >= item.type
            ? 'level certified'
            : 'level unauthorized'
        "
      >
        <div class="describe">
          <p class="title wx_fontSize3">{{ item.name }}</p>
          <p class="wx_fontSize2 detail" v-html="item.content"></p>
        </div>
        <img
          :src="dui"
          v-if="userInfo.auth_id >= item.type"
          alt
          class="wx_rt state"
        />
      </div>
    </div>
  </div>
</template>

<script>
import dui from "../../assets/img/coinDetail/ico_dui_lv.png";
import go from "../../assets/img/coinDetail/ico_jinru_lan.png";
import { httpGetSecList, httpGetKSToken } from "@/api/userCenter";
import { faceRecognize } from "@/utils/index";
import { Toast } from "mint-ui";
export default {
  data() {
    return {
      userInfo: this.$store.state.userInfo,
      dui: dui,
      go: go,
      list: [],
      ksToken: "",
    };
  },
  mounted: function () {},
  methods: {
    goWhere: function (index) {
      switch (index) {
        case 3:
          if (this.userInfo.auth_id != 2) return;
          // this.$router.push("/levelThree");
          break;
        case 4:
          if (this.userInfo.auth_id != 3) return;
          // this.getKSToken()
          break;
        case 5:
          break;
      }
    },
    getList: function () {
      // 获取认证等级列表
      httpGetSecList()
        .then((res) => {
          this.list = res.data;
        })
        .catch(() => {});
    },
    getKSToken: function () {
      httpGetKSToken()
        .then((res) => {
          this.ksToken = res.data.biz_token;
          faceRecognize(
            JSON.stringify({
              token: this.$store.state.token,
              ksToken: this.ksToken,
            })
          );
        })
        .catch(() => {});
    },
    faceRecognizeResult: function (satus, res) {
      Toast(res.toString());
    },
  },
  created() {
    window.faceRecognizeResult = this.faceRecognizeResult;
  },
  computed: {},
  watch: {
    "$store.state.userInfo": function (val, oldVal) {
      this.userInfo = val;
    },
  },
  activated: function () {
    this.getList();
  },
};
</script>

<style scoped>
#securityLevel {
  width: 100%;
  height: 100%;
  position: relative;
  background: #f6f6f6;
}
.mint-header {
  background: #ffffff;
  color: #212529;
  border-bottom: 1px solid #e3e8ed;
}
.mint-button--default {
  color: #656b79 !important;
}
.content {
  background: #f6f6f6;
  padding: 50px 15px 20px 15px;
}
.swiper {
  background-color: transparent;
  box-sizing: border-box;
  border-radius: 10px;
  color: #4a4a4a;
  padding: 10px;
  box-sizing: border-box;
  padding-top: 20px;
}
.swiper p {
  margin: 5px;
}
.level {
  padding: 10px 15px;
  background: #fff;
  box-shadow: 0 0 20px rgba(5, 61, 109, 0.2);
  border-radius: 5px;
  margin-top: 20px;
}
.describe {
  width: 90%;
  position: relative;
}
.title {
  color: #212529;
  font-weight: bold;
  padding: 5px 0 10px 0;
}
.detail {
  color: #888;
  line-height: 20px;
  font-weight: 500;
}
.state {
  width: 18px;
  height: 18px;
  margin-top: -16%;
}
.certified {
  border-left: 3px solid #00b191;
}
.authentication {
  border-left: 3px solid #1296db;
}
.unauthorized {
  border-left: 3px solid #bdc5dc;
}
.tip {
  font-weight: normal;
  color: #888;
}
</style>
